<template>
  <nuttrema-layout-default-slide>

    <template slot="overflow">
      <page-help
         v-if="show.pageHelp"
         file="participants"
        :title="$t('label.help')"
        :anchor="`#${$route.name}`"
        @close="show.pageHelp = false">
      </page-help>
    </template>

    <nuttrema-brand-image slot="collapsed-menu-top-brand" link="professional-home"></nuttrema-brand-image>

    <template slot="collapsed-menu-top">

      <participant-section-add-new-options :id="id"></participant-section-add-new-options>

      <nuttrema-menu-list theme="sidebar-menu" class="in-collapsed">
        <nuttrema-menu-list-item>
          <router-link
             tag="a"
            :title="$t('label.index_list')"
            :to="{ name: _get(meta, 'navigation.cancel') }">
            <nuttrema-iconica-sidebar-link theme="gray" icon="far fa-arrow-left"></nuttrema-iconica-sidebar-link>
          </router-link>
        </nuttrema-menu-list-item>

        <nuttrema-menu-list-item>
          <sidebar-icon-level-zero></sidebar-icon-level-zero>
        </nuttrema-menu-list-item>
      </nuttrema-menu-list>
    </template>

    <template slot="sidebar-collapsed-bottom">
      <nuttrema-menu-list>
        <nuttrema-menu-list-item>
          <sidebar-link-overlay-usermenu icon="fas fa-th" title="test"></sidebar-link-overlay-usermenu>
        </nuttrema-menu-list-item>
      </nuttrema-menu-list>
    </template>

    <sidebar-menu-level-zero-collapsed
      slot="collapsed-menu-level-zero"
      class="collapsed-menu-level-zero is-collapsed">
    </sidebar-menu-level-zero-collapsed>

    <sidebar-menu-participant-collapsed
       slot="collapsed-menu-level-one"
       class="collapsed-menu-level-one is-collapsed"
      :id="id">
    </sidebar-menu-participant-collapsed>

    <sidebar-menu-participant-expanded
       slot="expanded-menu-level-one"
       class="expanded-menu-level-one is-expanded"
      :id="id"
      :meta="meta"
      :PersonDetails="PersonDetails">
    </sidebar-menu-participant-expanded>
  </nuttrema-layout-default-slide>
</template>

<script>
import AbstractLayoutSetDetails from 'components/ui/layout-set/abstract/abstract-layout-set-details';

import ParticipantSectionAddNewOptions from 'components/pages/professional/persons/participants/shared/blocks/cmpt-participant-section-add-new-options';

import SidebarMenuLevelZeroCollapsed from 'components/ui/menu/level-zero/sidebar-menu-level-zero-collapsed';

import SidebarMenuParticipantExpanded from 'components/ui/menu/persons/sidebar-menu-participant-expanded';
import SidebarMenuParticipantCollapsed from 'components/ui/menu/persons/sidebar-menu-participant-collapsed';

export default {
  name: 'layout-set-participant-details',
  mixins: [AbstractLayoutSetDetails],
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
    meta: {
      required: false,
      default: null,
    },
  },
  components: {
    SidebarMenuLevelZeroCollapsed,
    SidebarMenuParticipantExpanded,
    ParticipantSectionAddNewOptions,
    SidebarMenuParticipantCollapsed,
  },
  data() {
    return {
      show: {
        pageHelp: false,
      },
    };
  },
  methods: {
    fetchDetails() {
      this.$store.dispatch('GetPersonDetails', { id: this.id, type: this.type });
    },
    clearDetails() {
      this.$store.dispatch('ClearPersonDetails', { id: this.id });
    },
  },
  computed: {
    PersonDetails() {
      return this.$store.getters.PersonDetails(this.id);
    },
  },
  created() {
    this.$on(this.EVENT.SHOW_PAGE_HELP, () => {
      this.show.pageHelp = true;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/persons/layout-set-participant-details.vue